import { useEffect, useState } from 'react';

/**
 * Renders the Welding department email address (Soudage@kenscho.ca) 
 * that's protected from bot crawlers.
 * The email is obfuscated in the source code and only assembled via JavaScript,
 * which most bots don't execute.
 */
export const ObfuscatedWeldingEmail = ({ className = '' }) => {
  const [email, setEmail] = useState('');
  
  useEffect(() => {
    // Obfuscated parts - bots can't easily parse this
    // "Soudure" = 83, 111, 117, 100, 117, 114, 101
    const user = String.fromCharCode(83, 111, 117, 100, 117, 114, 101);
    const at = String.fromCharCode(64); // "@"
    const domain = String.fromCharCode(75, 101, 110, 115, 99, 104, 111); // "Kenscho"
    const tld = String.fromCharCode(46, 99, 97); // ".ca"
    
    // Assemble after a tiny delay to further confuse crawlers
    const timer = setTimeout(() => {
      setEmail(`${user}${at}${domain}${tld}`);
    }, 10);
    
    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    // Create the mailto: link dynamically
    // "Soudure" = 83, 111, 117, 100, 117, 114, 101
    const user = String.fromCharCode(83, 111, 117, 100, 117, 114, 101);
    const at = String.fromCharCode(64);
    const domain = String.fromCharCode(75, 101, 110, 115, 99, 104, 111); // "Kenscho"
    const tld = String.fromCharCode(46, 99, 97);
    window.location.href = `mailto:${user}${at}${domain}${tld}`;
  };

  return (
    <button 
      onClick={handleClick}
      className={`hover:text-primary transition-colors cursor-pointer text-left ${className}`}
      aria-label="Email welding department"
      data-testid="welding-email-address"
    >
      {email || '••••••@•••••••.••'}
    </button>
  );
};
